/**
 * Canonical backdrop-blur scale (design-approved). Tailwind-style names mapped onto
 * the blur strengths the app actually uses, `lg` (20px) being the de-facto default.
 *
 * Flat string length constants, not an object: they resolve inside `@digits-css`
 * `css`/`styled` blocks — e.g. `backdrop-filter: blur(${BLUR_MD})` — whereas member
 * access (`BLUR.md`) can't be statically extracted by the production build.
 */
export const BLUR_XS = "2px"
export const BLUR_SM = "4px"
export const BLUR_MD = "8px"
export const BLUR_LG = "20px"
export const BLUR_XL = "40px"
export const BLUR_2XL = "100px"

/** Ordered scale (name → length) for token galleries / docs. */
export const BLUR_SCALE = [
  ["xs", BLUR_XS],
  ["sm", BLUR_SM],
  ["md", BLUR_MD],
  ["lg", BLUR_LG],
  ["xl", BLUR_XL],
  ["2xl", BLUR_2XL],
] as const
